import React, { Fragment } from 'react';
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import cellEditFactory from 'react-bootstrap-table2-editor';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

const DataTable = (props) => {
    const {
        data,
        page = 1,
        sizePerPage,
        onTableChange,
        keyField,
        columns,
        totalSize,
        seletedIds,
        handleCheck,
        hideSelectAll,
        hideSelect,
        handleSelectAll,
        updateRowData,
        hideSizePerPage = true,
        getClassName,
    } = props;

    const sizePerPageList = [
        {
            text: '10',
            value: 10
        },
        {
            text: '50',
            value: 50
        },
        {
            text: '100',
            value: 100
        },
        {
            text: '200',
            value: 200
        },
        // {
        //     text: 'All',
        //     value: totalSize
        // }
    ];
    
    return (
        <Fragment>
            <BootstrapTable
                remote
                keyField={keyField}
                data={data}
                noDataIndication="No users found"
                rowClasses={getClassName}
                columns={columns.map(col => {
                    if (col.dataField === "name") {
                      return {
                        ...col,
                        formatter: (cell) => (
                          <OverlayTrigger
                            placement="top"
                            overlay={<Tooltip>{cell}</Tooltip>}
                          >
                            <span className="text-truncate d-inline-block" style={{ maxWidth: "150px" }}>
                              {cell}
                            </span>
                          </OverlayTrigger>
                        )
                      };
                    }
                    return col;
                  })}
                pagination={paginationFactory({ page, sizePerPage, totalSize, hideSizePerPage: hideSizePerPage, sizePerPageList: sizePerPageList })}
                onTableChange={onTableChange}
                cellEdit={updateRowData && cellEditFactory({
                    mode: 'click',
                    blurToSave: true,
                    beforeSaveCell: (oldValue, newValue, row, column, done) => { updateRowData(oldValue, newValue, row, column); done(false); },
                    // nonEditableRows: () => selectedIndx,
                    nonSelectableClasses: 'non-clikable-row'
                })}
                selectRow={{ mode: 'checkbox', hideSelectColumn: hideSelect, onSelect: handleCheck, hideSelectAll: hideSelectAll, onSelectAll: handleSelectAll, selected: seletedIds }}
            />
        </Fragment>
    )
}
export default DataTable;